export default __webpack_public_path__ + "static/media/register.ae2be7d5.png";